import React, { Component } from 'react'
import { post, get } from '../../utils/networking'
import Footer from '../footer'
import $ from "jquery"
import * as Notification from '../../notification'

export default class ForgotPasswordForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: document.getElementsByClassName("form")
        }
    }

    showForm() {
        var form = document.getElementById("forgot_password_form");
        form.classList.toggle("show_form");
        this.resetForm();
    }

    resetForm() {
        for (var i = 0; i < this.state.form.length; i++) {
            this.state.form[i].classList.remove("hide");
            if (i > 0) {
                this.state.form[i].classList.add("hide");
            }
        }
    }

    checkMail() {
        Notification.hide();
        let mail_value = this.refs.email_for_reset.value.replace(/\s/g, "");
        let user = (this.props.isPartner) ? "partner" : "customer";
        if (this.checkMailValue(mail_value)) {
            $("#fa-spinner").fadeIn();
            get('user/forgotPassword/' + encodeURIComponent(mail_value), user, result => {
                this.state.form[0].classList.toggle("hide");
                this.state.form[1].classList.toggle("hide");
                $("#fa-spinner").fadeOut();
            }, errors => {
                Notification.show($("#submit_mail"), errors.errors[0], "fail", "0");
            })
            $("#fa-spinner").fadeOut();
        }
        else {
            Notification.show($(".input_mail"), "Please match the requested email format.", "fail", "1");
        }
    }

    checkPass(value) {
        return (value && /^(?=.*[A-Za-z*!@#$%^&()])(?=.*\d)[A-Za-z*!@#$%^&()\d]{8,}$/g.test(value))
    }

    resetPassword() {

        Notification.hide();
        var newPass = {
            email: this.refs.email_for_reset.value.toLowerCase(),
            otp: this.refs.verify_code.value,
            newPassword: this.refs.new_password.value,
            confirmPassword: this.refs.retype_new_password.value
        }
        if (!this.checkPass(newPass.newPassword)) {
            Notification.show($(".new_password"), "New password must be minimum eight characters, at least one letter and one number.", "fail", "0");
        }
        else {
            if (newPass.newPassword != newPass.confirmPassword) {
                Notification.show($(".retype_new_password"), "New password and confirm password not match", "fail", "0");
            }
            else {
                let user = (this.props.isPartner) ? "partner" : "customer";
                post('user/resetPassword/', newPass, user, result => {
                    Notification.show($("#submit_reset"), "Your password has been reset.", "success", "0");
                    setTimeout(() => {
                        window.location.href = "/login"
                    }, 5000);
                }, errors => {
                    Notification.show($("#submit_reset"), errors.errors[0], "fail", "0");
                })
            }
        }
    }

    resetFormAndClose() {
        Notification.hide();
        this.refs.email_for_reset.value = "";
        this.refs.verify_code.value = "";
        this.refs.new_password.value = "";
        this.refs.retype_new_password.value = "";
        this.showForm();
    }

    checkMailValue(mail) {
        var regExp = new RegExp("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$");
        return regExp.test(mail);
    }

    render() {

        return (
            <div id="forgot_password_form" className="forgot_password_form">
                <span className="close_button">
                    <i className="fa fa-times" aria-hidden="true" onClick={this.resetFormAndClose.bind(this)}></i>
                </span>
                <div className="form_detail">
                    <div className="form config_mail">
                        <p className="header">Forgot Password</p>
                        <p className="message">Please enter the email address with your account to reset your password.</p>
                        <input className="input_mail" type="text" ref="email_for_reset" placeholder="Your email" />
                        <div id="submit_mail">
                            <button className="submit" onClick={this.checkMail.bind(this)}><i className="fa fa-spinner fa-pulse fa-3x fa-fw" id="fa-spinner" style={{ display: "none" }}></i>Continue...</button>
                        </div>
                    </div>
                    <div className="form renew_password_form hide">
                        <p className="header">Reset Password</p>
                        <p className="message">Please enter new password 2x below to reset.</p>
                        <input className="input_verify_code" type="text" ref="verify_code" placeholder="Verification code" />
                        <input className="new_password" type="password" ref="new_password" placeholder="New Password" />
                        <input className="retype_new_password" type="password" ref="retype_new_password" placeholder="Retype Password" />
                        <div id="submit_reset">
                            <button className="submit" onClick={this.resetPassword.bind(this)}>Reset Password</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/forgotPassword/index.js